export const APP_CONFIG = {
  currency: {
    symbol: '£',
    code: 'GBP',
    name: 'British Pounds'
  },
  portalDebateUrl: 'https://portal.tribescapital.com/debate/hidden-tax-discussion',
  exampleValues: {
    litres: 1000,
    pricePerLitre: 1.20,
    hours: 120,
    avgLoad: 10
  },
  limits: {
    maxHoursPerMonth: 744, // 31 days * 24 hours
    largeValueThreshold: 100000
  },
  allInMultipliers: {
    low: 1.2, // 20% markup
    high: 1.4 // 40% markup
  }
};